import { Box, SxProps, Theme } from '@mui/material';
import { alpha } from '@mui/system';

interface CompareHighlightWrapperProps {
  isActive: boolean;
  children: React.ReactNode;
  shouldShowOutline?: boolean;
  sx?: SxProps<Theme>;
}

export const CompareHighlightWrapper = ({
  isActive,
  shouldShowOutline = false,
  children,
  sx = {},
}: CompareHighlightWrapperProps) => {
  return (
    <Box
      sx={{
        ...sx,
        backgroundColor: (theme) =>
          isActive ? alpha(theme.palette.info.main, 0.1) : undefined,
        outline: (theme) =>
          isActive && shouldShowOutline
            ? `1px solid ${alpha(theme.palette.info.main, 0.6)}`
            : 'none',
      }}
    >
      {children}
    </Box>
  );
};
